import React from "react";
import { useNavigate } from "react-router-dom";

const Menu = () => {
  const navigate = useNavigate();

  return (
    <div className="pt-[3px]">
      <div className="rounded-t-[20px] w-full bg-rose-500 text-primary-content">
        <div className="card-body py-3 items-center text-center">
          <img className="w-[30px]" src="/culogo.png" alt="" srcset="" />
          <h2 className="card-title text-white">University of Chittagong</h2>
          <p className="italic text-white">Get latest update in "cuFeeds" </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 mx-2 pt-5">
        <div
          onClick={() => navigate("/Notices")}
          className="card w-full bg-zinc-200 text-primary-content"
        >
          <div className="card-body items-center text-center">
            <h2 className="card-title text-black">Notices</h2>
          </div>
        </div>
        <div
          onClick={() => navigate("/Admission")}
          className="card w-full bg-zinc-200 text-primary-content"
        >
          <div className="card-body items-center text-center">
            <h2 className="card-title text-black">Admission</h2>
          </div>
        </div>
        <div
          onClick={() => navigate("/CampusNews")}
          className="card w-full bg-zinc-200 text-primary-content"
        >
          <div className="card-body items-center text-center">
            <h2 className="card-title text-black">Campus News</h2>
          </div>
        </div>
        {/* <div
          onClick={() => navigate("/CampusLife")}
          className="card w-full bg-zinc-200 text-primary-content"
        >
          <div className="card-body items-center text-center">
            <h2 className="card-title text-black">Campus Life</h2>
          </div>
        </div> */}

        <div
          onClick={() => navigate("/ContactUs")}
          className="card w-full bg-zinc-200 text-primary-content"
        >
          <div className="card-body items-center text-center">
            <h2 className="card-title text-black">Contact Us</h2>
          </div>
        </div>
        <div
          onClick={() => navigate("/PrivacyPolicy")}
          className="card w-full bg-zinc-200 text-primary-content"
        >
          <div className="card-body items-center text-center">
            <h2 className="card-title text-black">Privacy Policy</h2>
          </div>
        </div>

        <div
          onClick={() => navigate("/Credits")}
          className="card w-full bg-zinc-200 text-primary-content"
        >
          <div className="card-body items-center text-center">
            <h2 className="card-title text-black">App Credits</h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Menu;
